import { Component, OnInit, OnDestroy } from '@angular/core'
import { GlobalService } from 'src/app/services/global.service'
import { EnterpriseContextService } from 'src/app/services/enterprise-context.service'
import { AuthenticationService } from 'src/app/services/authentication.service'
import { EnterpriseConfig } from 'src/app/config/enterprise.config'
import { Subscription } from 'rxjs'

@Component({
    selector: 'admin-app-header',
    templateUrl: './admin-header.component.html',
    styleUrls: ['./admin-header.component.scss'],
})
export class AdminHeaderComponent implements OnInit, OnDestroy {
    availableEnterprises: EnterpriseConfig[] = []
    currentEnterprise: EnterpriseConfig | null = null
    private enterpriseSubscription: Subscription

    constructor(public globalService: GlobalService, public enterpriseContext: EnterpriseContextService, public authService: AuthenticationService) {}

    ngAfterViewInit() {
        document.addEventListener('click', this.closeContextMenu.bind(this))
    }

    ngOnInit(): void {
        // Subscribe to enterprise changes
        // Note: Enterprise context is initialized by AuthenticationService after auth is complete
        this.enterpriseSubscription = this.enterpriseContext.currentEnterprise$.subscribe((enterprise) => {
            this.currentEnterprise = enterprise
        })

        // Load available enterprises for dropdown
        this.availableEnterprises = this.enterpriseContext.getAvailableEnterprises()
    }

    ngOnDestroy(): void {
        if (this.enterpriseSubscription) {
            this.enterpriseSubscription.unsubscribe()
        }
    }

    closeContextMenu(event: MouseEvent) {
        this.globalService.hideContextMenu()
    }

    /**
     * Handle enterprise selection from dropdown.
     * This filters admin data by enterprise (doesn't change UI branding - that's domain-based).
     */
    onEnterpriseSelect(enterpriseKey: string | null): void {
        this.enterpriseContext.setEnterprise(enterpriseKey)
    }

    /**
     * Check if "All Enterprises" is selected
     */
    get isAllEnterprisesSelected(): boolean {
        return this.currentEnterprise === null
    }
}
